import { render, staticRenderFns } from "./CustomTable.vue?vue&type=template&id=6ea776cb"
import script from "./CustomTable.vue?vue&type=script&lang=js"
export * from "./CustomTable.vue?vue&type=script&lang=js"
import style0 from "./CustomTable.vue?vue&type=style&index=0&id=6ea776cb&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports